import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
export const Swimmlane = ({ children, className, }) => {
    return (_jsx("div", { className: cn('text-text-secondary-foreground bg-surface-button-secondary mx-auto mt-6 max-w-md rounded-md px-2 py-1 text-center text-sm leading-4 font-semibold', className), children: children }));
};
